<script setup lang="ts">
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { useUserStore } from "../../store/userStore";
import { useOrgStore } from "../../store/orgStore";
import { markLoggedOut } from "../../utils/useAuth";

import axios from "axios";
import AxiosOrgService from "../../utils/axiosOrgService";
import { useLanguage } from "../../utils/useLanguage";
const { t } = useLanguage();
// ================ Initial Org ================
const orgStore = useOrgStore();
const userStore = useUserStore();

// ================ User Logout ================
const router = useRouter();
const axiosJsonToken = axios.create({
    withCredentials: true,

  headers: {
    "content-type": "application/json",
    credentials: "include",
    Authorization: "Bearer " + localStorage.token + "",
  },
});

const logout = () => {
  localStorage.removeItem("token");
  axiosJsonToken
    .post("/api/v1/user/logout")
    .then(function (res) {
      markLoggedOut();
      router.push("/admin/login");
    })
    .catch(function (res) {
      console.log("logout error", res);
    });
};

const isSidebarOpen = ref(false);
const openIndexes = ref<number[]>([]);

function toggle(index: number) {
  if (openIndexes.value.includes(index)) {
    openIndexes.value = openIndexes.value.filter((i) => i !== index);
  } else {
    openIndexes.value.push(index);
  }
}
const openSubIndexes = ref<number>();

function toggleSub(index: number) {
  openSubIndexes.value = index
}
const userAlertItems = [
  {
    to: "/user/center",
    icon: "icon-dashboard",
    label: "Dashboard", // 用作 i18n key
  },
  {
    to: "/user/notification",
    icon: "icon-alert",
    label: "Notification",
  },
];

const userNavItems = [
{
    icon: "icon-book",
    label: "Vocabulary",
    children: [
      { to: "/user/vocabulary/notebook", label: "Notebook" },
      { to: "/user/vocabulary/flipcard", label: "Flip Card" },
      { to: "/user/vocabulary/lookup", label: "Lookup History" },
    ],
  },
  {
    icon: "icon-subtitles",
    label: "Watch",
    children: [
      { to: "/user/watch/sentencelist", label: "Sentence" },
      // { to: "/user/watch/videolist", label: "Uploaded Video" },
    ],
  },
  {
    to: "/user/activities",
    icon: "icon-speak",
    label: "Speak",
  },
  {
    to: "/user/record",
    icon: "icon-micro",
    label: "Recording",
  },
  {
    to: "/user/quiz",
    icon: "icon-exam",
    label: "Quiz",
  },


];



onMounted(async () => {
  userStore.getUser();
  await orgStore.getAllInfo();
  console.log(userStore.user_role);
});
</script>

<template>
<header class="dHeader flex gap-10 p-10 barLine md-block">
<router-link to="/">
  <span class="icon-menu lg" @click="isSidebarOpen = true"></span>
  <img class="logo-sm" src="/logo_2024_black.png" alt="" />
</router-link>
</header>

<nav class="sidebar bg-white-3 flex column a-center scroll md-none pad-block">
  <div style="width: 100%">
    <div class="p-10 barLine">
      <router-link to="/" class="flex gap-10 a-center p-10 br-10 pointer">
        <img class="logo-sm" src="/logo-icon.png" alt="" />
    </router-link>
      <div class="flex gap-10 a-center p-10 br-10 pointer" @click="isSidebarOpen = true">
        <span class="icon-ham md"></span>
      </div>
    </div>

    <div class="p-10 barLine">
      <router-link
        v-for="(item, index) in userAlertItems"
        :key="index"
        :to="item.to"
        class="sideItem flex gap-10 j-center a-center p-10 br-10"
      >
        <span :class="item.icon" class="md"></span>
        <span class="tag bg-pr white-1" v-if="item.to === '/user/notification' && userStore.unread_notifications > 0">{{ userStore.unread_notifications }}</span>
      </router-link>
    </div>

    <div class="p-10 barLine">
      <div v-for="(item, index) in userNavItems" :key="index">
        <router-link
          v-if="!item.children"
          :to="item.to"
          class="sideItem flex j-center a-center p-10 br-10 rel"
        >
          <span :class="item.icon" class="lg"></span>
        </router-link>

        <div v-else class="sideItem flex j-center a-center p-10 br-10 pointer">
          <span :class="item.icon" class="lg" @click="toggleSub(index)"></span>
          <div class="bg-white-3 br-10 p-10 abs flex column sub">
            <router-link
              v-for="(child, cIndex) in item.children"
              :key="cIndex"
              :to="child.to"
              class="sideItem p-10 br-10 pointer"
            >
              <span class="label">{{ t(child.label) }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="p-10">
      <router-link class="sideItem flex gap-10 j-center a-center p-10 br-10" to="/setting" target="_blank">
        <span class="icon-fixed md"></span>
      </router-link>
      <router-link class="sideItem flex gap-10 j-center a-center p-10 br-10" to="/">
        <span class="icon-home md"></span>
      </router-link>
    </div>
  </div>
</nav>

<nav class="sidebar pc bg-white-2 flex column a-center scroll pad-none" :class="isSidebarOpen ? 'active' : ''">
  <div style="width: 100%">
    <router-link class="flex j-between a-center p-10 barLine" to="/">
      <img class="logo-sm" src="/logo_2024_black.png" alt="" />
      <span class="pointer icon-close md-block" @click="isSidebarOpen = false"></span>
    </router-link>

    <div class="p-10 barLine">
      <router-link
        v-for="(item, index) in userAlertItems"
        :key="index"
        :to="item.to"
        class="sideItem flex gap-10 a-center p-10 br-10"
      >
        <span :class="item.icon" class="md"></span>
        <span class="label">{{ t(item.label) }}</span>
        <span class="tag bg-pr white-1" v-if="item.to === '/user/notification' && userStore.unread_notifications > 0">{{ userStore.unread_notifications }}</span>
      </router-link>
    </div>

    <div class="p-10 barLine">
      <h4 class="fs-075r fw-medium black-5 p-10">{{ t('Learning Records') }}</h4>
      <div v-for="(item, index) in userNavItems" :key="index" class="sideItem-wrap">
        <router-link
          v-if="!item.children"
          :to="item.to"
          class="sideItem flex gap-10 a-center p-10 br-10"
        >
          <span :class="item.icon" class="md"></span>
          <span class="label">{{ t(item.label) }}</span>
        </router-link>

        <div v-else>
          <!-- 主項目 -->
          <div
            class="sideItem flex a-center j-between p-10 br-10 pointer"
            :class="openIndexes.includes(index) ? 'active' : ''"
            @click="toggle(index)"
          >
            <div class="flex gap-10 a-center">
              <span :class="item.icon" class="md"></span>
              <span class="label">{{ t(item.label) }}</span>
              
            </div>
            <span class="dropdown icon-down" :class="openIndexes.includes(index) ? 'active' : ''"></span>
          </div>

          <!-- 子項目 -->
          <div v-if="openIndexes.includes(index)" class="flex column gap-5">
            <router-link
              v-for="(child, cIdx) in item.children"
              :key="cIdx"
              :to="child.to"
              class="sideItem flex gap-10 a-center p-10 br-10 pointer"
            >
              <span class="label ml-20">- {{ t(child.label) }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="p-10">
      <router-link class="sideItem flex gap-10 a-center p-10 br-10" to="/setting">
        <span class="icon-fixed md"></span>
        <span class="label">{{ t('Account Setting') }}</span>
      </router-link>
      <router-link class="sideItem flex gap-10 a-center p-10 br-10" to="/">
        <span class="icon-home md"></span>
        <span class="label">{{ t('Back to Platform') }}</span>
      </router-link>
    </div>
  </div>
</nav>

</template>

<style scoped>
@import "../../assets/css_lib/themimir.css";
.dHeader {
  height: 50px;
}
.sidebar {
  width: 65px;
  height: 100vh;
}

.sidebar.pc {
  width: 250px;
}

@media all and (max-width: 768px){

  .sidebar.pc {
    display: flex;
    position: absolute;
    left: 0;
    transform: translateX(-100%);
    transition: 1s;
    z-index: 99;
  }
  .sidebar.pc.active {
    left: 0;
    transform: translateX(0);
  }
}
.sideItem:hover,
.sideItem.active {
  background-color: #f2f2f2;
}
.sub {
  left: 55px;
  z-index: 99;
  transform: translateY(-40px);
  display: none;
}
.sideItem.active > .sub,
.sideItem:hover > .sub {
  display: flex;
}
.barActive {
  position: absolute;
  left: 50px;
  background: #f2f2f2;
  width: 20px;
  height: 30px;
  border-radius: 5px;
}

.navItem:hover > span,
.navItem.active > span {
  font-weight: 600;
}

.dropdown {
  transition: all 0.5s;
}
.dropdown.active {
  transform: rotate(180deg);
}
.barLine {
  border-bottom: 1px solid #eee;
}
</style>